export default {
  root: {
    '&:last-child': {
      paddingBottom: '0px'
    }
  }
};
